<div style="margin-bottom:20px;display:flex;">
  <table class="detailTable" style="width:95%;">
    <tr class="detailTableHeader">
      <th style="width:10%;">Line</th>
      <th style="width:70%;">Part Number</th>
      <th style="width:20%;">Estimated Lead Time</th>
    </tr>
    <tr>
      <td style="border: 1px solid black; text-align: center;">{{CurrentDetail.QuoteLine}}</td>
      <td style="border:1px solid black; text-align:center;">
        <div class="row-no-margin clear-padding">
          
          <div style="width:85%;text-align:center;padding-left:15%;">{{CurrentDetail.ConfigString + CurrentDetail.Item}}</div>
          <div style="width:15%;text-align:right;"><button [hidden]="CurrentDetail.LineType != 'cl'" class="clickable blue smallButton" (click)="Reconfigure()">Reconfigure</button></div>
        </div>
      </td>
      <td style="border: 1px solid black; text-align: center;">
        @if(CurrentDetail.LineType != 'sp'){
        {{CurrentDetail.EstimatedLeadTimeString}}
        }
        @else{
        <input class="smallInput " [(ngModel)]="CurrentDetail.EstimatedLeadTimeString" [ngModelOptions]="{updateOn:'blur'}"  />
        }

      </td>
    </tr>
    <tr>
      <td colspan="3" class="clear-padding">
        <div class="row-no-margin col-md-12 clear-padding">
          <div style="width:85%;">
            <table class="assDetailTable"  style="width:100%;text-align:center;">
              <tr class="assDetailHeader">
                <th style="width:60%;"><span style="text-decoration:underline;">Assembly Details&nbsp;</span><fa-icon [hidden]="CurrentDetail.LineType != 'cl'" [icon]="faEdit" (click)="EditAssemblyDetail()" class="clickable fa-lg blue-color"></fa-icon></th>
                <th style="width:40%;"><span style="text-decoration:underline;">Product Notes</span><fa-icon [hidden]="CurrentDetail.LineType != 'cl'" [icon]="faEdit" (click)="EditProductDetail()" class="clickable fa-lg blue-color"></fa-icon></th>
              </tr>
              <tr>
                <td style="text-align:left;">
                  @if(CurrentDetail.LineType == 'cl'){
                  @for(colCount of GetAssDetailColumnCount() | range; track colCount){
                  <div [class]="GetAssDetailWidthClass()">
                    @for(rowCount of GetAssDetailRowCount() | range; track rowCount){
                    <span class="smallMargin assDetailText" style="display:block;" id="assDetail_{{rowCount}}_{{colCount}}">
                      {{GetAssDetailContent(rowCount, colCount)}}
                    </span>
                    }
                  </div>
                  <!--<table class="assDetailTable" style="width:90%;margin-left:auto;margin-right:auto;">
                    @for(rowCount of GetAssDetailRowCount() | range; track rowCount){
                    <tr>
                      @for(colCount of GetAssDetailColumnCount() | range; track colCount){
                      <td [class]="GetAssDetailWidthClass()">
                        @if(rowCount + (colCount * GetAssDetailRowCount()) < CurrentDetail.AssemblyDetails.length){
                        <span class="smallMargin assDetailText" id="assDetail_{{rowCount}}_{{colCount}}">
                          {{GetAssDetailContent(rowCount, colCount)}}
                        </span>-->
                        <!--<input class="smallInput smallMargin assDetailText" id="assDetail_{{rowCount}}_{{colCount}}" [value]="GetAssDetailContent(rowCount, colCount)" (change)="AssemblyDetail_Change($event,rowCount, colCount)" />-->
                        <!--{{GetAssDetailContent(rowCount, colCount)}}-->
                        <!--}
                      </td>
                      }
                    </tr>
                    }
                  </table>-->
                  }
                  }
                  @else{
                  <div style="display:flex;justify-content:center;">
                    <textarea [value]="GetAssDetailContent(0,0)" class="assDetailText" (change)="AssemblyDetail_Change($event,0, 0)" rows="4" cols="70"></textarea>
                  </div>
                  }
                </td>
                <td style="text-align:left;vertical-align:top;">
                  <span style="width:100%; height:100%;white-space:pre;">{{CurrentDetail.ProductNotes}}</span>
                  <!--<textarea [(ngModel)]="CurrentDetail.ProductNotes" class="assDetailText" rows="4" cols="70"></textarea>-->
                </td>
              </tr>
              <!--Line Note-->
              <tr>
                <td>
                  <div [hidden]="CurrentDetail.LineNote.length == 0" style="text-align:left;border:1px black solid;padding:2px;">
                    <span><b>Note:</b>{{CurrentDetail.LineNote}}</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div style="width:15%;">
            <table class="detailTable" style="width:100%;text-align:center; border-top:none !important;border-bottom:none !important;">
              <tr class="detailTableHeader">
                <th style="border:1px solid black;"></th>
                <th style="border:1px solid black;">{{IsDirectCustomer ? "" : "List "}}Price (EA)</th>
                <th style="border:1px solid black;"><input class="currency" [ngModel]="CurrentDetail.ListPrice | currency" [ngModelOptions]="{updateOn:'blur'}" (ngModelChange)="AdjustUnitPrice($event)" /></th>
                
              </tr>
              <tr>
                <td style="border:1px solid black;text-align:center;">QTY</td>
                <td style="border: 1px solid black; text-align: center;">Break %</td>
                <td style="border: 1px solid black; text-align: center;">
                  Unit Price&nbsp;
                  <fa-icon [icon]="faAdd" (click)="AddPriceBreak()"  class="clickable fa-lg blue-color"></fa-icon>
                </td>                
              </tr>
              <!--Price Break 1-->
              <tr [hidden]="CurrentDetail.BreakQty1 == 0">
                <td><input class="qty" appSelectOnFocus [value]="GetBreakQtyString(0)" (change)="AssignBreakQty($event.target.value,0)" /></td>
                <td><input class="qty" appSelectOnFocus [ngModel]="GetBreakPercString(0) | percent:'0.0'"  [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPerc($event.target.value,0)" /></td>
                <td class="priceCell"><input class="currency" appSelectOnFocus [ngModel]="GetBreakPrice(0) | currency" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPrice($event,0)" /></td><!--(ngModelChange)="AssignBreakPrice($event,0)"-->

              </tr>
              <tr [hidden]="CurrentDetail.BreakQty2 == null || CurrentDetail.BreakQty2 == undefined || CurrentDetail.BreakQty2 == 0">
                <!--Price Break 2-->
                <td><input class="qty" appSelectOnFocus [value]="GetBreakQtyString(1)" (change)="AssignBreakQty($event.target.value,1)" /></td>
                <td><input class="qty" appSelectOnFocus [ngModel]="GetBreakPercString(1) | percent:'0.0'" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPerc($event.target.value,1)" /></td>
                <td class="priceCell"><input class="currency" appSelectOnFocus [ngModel]="GetBreakPrice(1) | currency" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPrice($event,1)" /><fa-icon [icon]="faX" [hidden]="CurrentDetail.BreakQty3 > 0" (click)="DeletePriceBreak(1)" class="clickable blue-color" style="padding-left:3px;"></fa-icon></td>

              </tr>
              <tr [hidden]="CurrentDetail.BreakQty3 == null || CurrentDetail.BreakQty3 == undefined || CurrentDetail.BreakQty3 == 0">
                <!--Price Break 3-->
                <td><input class="qty" appSelectOnFocus [value]="GetBreakQtyString(2)" (change)="AssignBreakQty($event.target.value,2)" /></td>
                <td><input class="qty" appSelectOnFocus [ngModel]="GetBreakPercString(2) | percent:'0.0'" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPerc($event.target.value,2)" /></td>
                <td class="priceCell"><input class="currency" appSelectOnFocus [ngModel]="GetBreakPrice(2) | currency" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPrice($event,2)" /><fa-icon [icon]="faX" [hidden]="CurrentDetail.BreakQty4 > 0" (click)="DeletePriceBreak(2)" class="clickable blue-color" style="padding-left:3px;"></fa-icon></td>
              </tr>
              <tr [hidden]="CurrentDetail.BreakQty4 == null  || CurrentDetail.BreakQty4 == undefined || CurrentDetail.BreakQty4 == 0">
                <!--Price Break 4-->
                <td><input class="qty" appSelectOnFocus [value]="GetBreakQtyString(3)" (change)="AssignBreakQty($event.target.value,3)" /></td>
                <td><input class="qty" appSelectOnFocus [ngModel]="GetBreakPercString(3) | percent:'0.0'" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPerc($event.target.value,3)" /></td>
                <td class="priceCell"><input class="currency" appSelectOnFocus [ngModel]="GetBreakPrice(3) | currency" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPrice($event,3)" /><fa-icon [icon]="faX" [hidden]="CurrentDetail.BreakQty5 > 0" (click)="DeletePriceBreak(3)" class="clickable blue-color" style="padding-left:3px;"></fa-icon></td>
              </tr>
              <tr [hidden]="CurrentDetail.BreakQty5 == null  || CurrentDetail.BreakQty5 == undefined || CurrentDetail.BreakQty5 == 0">
                <!--Price Break 5-->
                <td><input class="qty" appSelectOnFocus [value]="GetBreakQtyString(4)" (change)="AssignBreakQty($event.target.value,4)" /></td>
                <td><input class="qty" appSelectOnFocus [ngModel]="GetBreakPercString(4) | percent:'0.0'" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPerc($event.target.value,4)" /></td>
                <td class="priceCell"><input class="currency" appSelectOnFocus [ngModel]="GetBreakPrice(4) | currency" [ngModelOptions]="{updateOn:'blur'}" (blur)="AssignBreakPrice($event,4)" /><fa-icon [icon]="faX" (click)="DeletePriceBreak(4)" class="clickable blue-color" style="padding-left:3px;"></fa-icon></td>
              </tr>
              <tr>
                <td style="border:1px solid black;" colspan="3"><a [hidden]="CurrentDetail.ProductURL == null" href="{{CurrentDetail.ProductURL}}">Link to {{CurrentDetail.LineType == 'cl' ? CurrentDetail.ConfigString.substring(0,3) : CurrentDetail.Item}}</a></td>
              </tr>
            </table>
          </div>
        </div>
      </td>
      </tr>
  </table>
  <span style="padding:5px;"><fa-icon [icon]="faX" (click)="DeleteLine()" class="clickable fa-lg blue-color"></fa-icon></span>
</div>
